<template>
  <!-- 专用于在card中显示金额 -->
  <span :class="'show-money ' + (showColor? 'show-color': '')">
    <span class="show-money-mark">
      <span v-if="showMark">￥</span>
      <span v-if="modelValue < 0">-</span>
    </span>
    <span class="show-money-main" v-for="(a, i) in data" :key="i">{{a}}<span v-if="notation && i < data.length - 1">,</span></span>
    <span>.</span>
    <span class="show-money-float">{{float}}</span>
    <span class="show-money-unit" v-if="showUnit">元</span>
  </span>
</template>

<script>

// 统一进行金额数据显示
import {watch} from "vue";
import numberUtil from "@/util/numberUtil";

export default {
  props: {
    modelValue: {type: [String, Number],default: ""},
    color: {default: null},
    // 是否显示金额符号
    showMark: {default: false},
    // 是否显示单位
    showUnit: {default: false},
    // 是否使用科学计数法
    notation: {default: true},
    // 是否显示为彩色
    showColor: {default: false},
    // 某些时候可以使用amount
    amount: {default: ""},
  },
  name: "Money",
  components: {
  },
  data() {
    return {
      data: [],
      float: "00",
    };
  },
  created() {
    this.init();
    watch(() => this.modelValue, () => this.init());
    watch(() => this.amount, () => this.init());
  },
  methods: {
    init() {
      let d = numberUtil.scientificNotationMoney(this.modelValue || this.amount);
      let data = d.split(".");
      this.data = [data[0]];
      this.float = data[1];
    }
  }
};
</script>

<style lang="scss" scoped>
.show-money{
  font-size: 14px;
  color: #999;
  .show-money-mark{

  }
  .show-money-main{
    font-size: 14px;
    font-weight: 600;
    color: #303133;
  }
  .show-money-float{
    font-size: 12px;
    color: #606266;
  }
  .show-money-unit{
    font-size: 12px;
  }
}
.show-color{
  .show-money-main{
    color: #073fda;
  }
  .show-money-float{
    color: #073fda;
  }
}
</style>